import React from 'react';
import { Formik, Form, Field , ErrorMessage } from "formik";
import { useContext } from 'react';
import { expertContext } from "../../../../context/expertcontext";
import Steps from './Steps';
import { estateSchema } from '../../../../validation/validation';
const Estate = ({zones,documents}) => {
    const {category,setTab,tab,setEstate , estate , attributes} = useContext(expertContext)
    const nextStep = ()=>{
        if(tab<6){
          setTab(tab+1)
        }
    }
    const previousStep = ()=>{
       if(tab>1){
        setTab(tab-1)
       }
    }
    return (
        <div>
        <Formik 
        initialValues={{
            ExCategoryText : estate.ExCategoryText || "",
            ExDocumentText : estate.ExDocumentText || "",
            ExZoneId:  estate.ExZoneId || "",
            ExCategoryId:  estate.ExCategoryId || "",
            ExDocumentId : estate.ExDocumentId ||"",
            addressInfo:{
                neighbourhood: estate.addressInfo?.neighbourhood ||"",
                street1: estate.addressInfo?.street1 ||"",
                street2: estate.addressInfo?.street2 ||"",
                alley1: estate.addressInfo?.alley1 ||"",
                alley2: estate.addressInfo?.alley2 ||"",
                plaque: estate.addressInfo?.plaque ||"",
                postCode: estate.addressInfo?.postCode ||"",
                address: estate.addressInfo?.address ||"",
            },
          }}
          validationSchema={estateSchema}
          onSubmit={(values , {resetForm}) => {
                // console.log(values)
                setEstate(values)
                nextStep()
          }}
          enableReinitialize={true}
        >
        {({
          isSubmitting,
          errors,
          setFieldValue,
          handleChange,
          touched,
        }) => ( 
            <Form>
            <div className="row  align-items-center soratkarshenasi-form">
            <div className="mb-3 col-12">
            <label className="mb-1 ms-2 d-flex label-form karshenasi-label" htmlFor="name"> آدرس : </label>
            <Field
            name="addressInfo.address"
            className="w-100 karshenasi-input px-2 "
            type='text'
          />
          <ErrorMessage
            name="addressInfo.address"
            render={(msg) => (
              <div className="text-danger">{msg}</div>
            )}
          />
            </div>
            <div className="mb-3 col-sm-4 ">
            <label className="mb-1 ms-2 d-flex label-form karshenasi-label" htmlFor="name">منطقه : </label>
            <Field
            name="ExZoneId"
            as="select"
            className="w-100 karshenasi-input px-2"
          >
          <option>لطفا یک گزینه انتخاب کنید</option>
          {
            zones.map((s,index)=>(
              <option key={index} value={s.id}>{s.name}</option>
            ))
           }
          </Field>
          <ErrorMessage
            name="ExZoneId"
            render={(msg) => (
              <div className="text-danger">{msg}</div>
            )}
          />
            </div>
            <div className="mb-3 col-sm-4">
            <label className="mb-1 ms-2 d-flex label-form karshenasi-label" htmlFor="name">نوع ملک : </label>
            <Field
            name="ExCategoryId"
            as="select"
            className="w-100 karshenasi-input px-2"
            onChange={(e)=>{
                handleChange(e);
                setFieldValue('ExCategoryText',e.target.options[e.target.selectedIndex].text)
            }}
          >
          <option>لطفا یک گزینه انتخاب کنید</option>
          {
            category.map((s,index)=>(
              <option key={index} value={s.id}>{s.name}</option>
            ))
           }
          </Field>
          <ErrorMessage
            name="ExCategoryId"
            render={(msg) => (
              <div className="text-danger">{msg}</div>
            )}
          />
            </div>    
            <div className="mb-3 col-sm-4">
            <label className="mb-1 ms-2 d-flex label-form karshenasi-label" htmlFor="name">نوع سند : </label>
            <Field
            name="ExDocumentId"
            as="select"
            className="w-100 karshenasi-input px-2"
            onChange={(e)=>{
                handleChange(e);
                setFieldValue('ExDocumentText',e.target.options[e.target.selectedIndex].text)
            }}
          >
          <option>لطفا یک گزینه انتخاب کنید</option>
          {
            documents.map((s,index)=>(
              <option key={index} value={s.id}>{s.name}</option>
            ))
           }
          </Field>
          <ErrorMessage
            name="ExDocumentId"
            render={(msg) => (
              <div className="text-danger">{msg}</div>
            )}
          />
            </div> 
            <div className="mb-3 col-sm-4">
            <label className="mb-1 ms-2 d-flex label-form karshenasi-label" htmlFor="name"> پلاک: </label>
            <Field
            name="addressInfo.plaque"
            className="w-100 karshenasi-input px-2 "
            type='text'
          />
          <ErrorMessage
            name="addressInfo.plaque"
            render={(msg) => (
              <div className="text-danger">{msg}</div>
            )}
          />
            </div>
            <div className="mb-3 col-sm-4">
            <label className="mb-1 ms-2 d-flex label-form karshenasi-label" htmlFor="name"> کد پستی: </label>
            <Field
            name="addressInfo.postCode"
            className="w-100 karshenasi-input px-2 "
            type='text'
          />
          <ErrorMessage
            name="addressInfo.postCode"
            render={(msg) => (
              <div className="text-danger">{msg}</div>
            )}
          />
            </div>
            </div>

            <div>
            <Steps/>
            <div className='mb-2 px-2 d-flex justify-content-between '>
            <div className=' request-next-btn-box  mt-2'>
            <button  type='submit' className='btn request-next-btn' >بعدی</button>
            </div>
            <div className=' request-Previous-btn-box mt-2 '>
            <button className='btn request-Previous-btn ' type='button' onClick={()=>{previousStep()}}>قبلی</button>
            </div>
            </div>
            </div>
            </Form> )}
            </Formik>
        </div>
    );
};

export default Estate;
